import { render, staticRenderFns } from "./BaseDateField.vue?vue&type=template&id=c4dd2762&scoped=true"
import script from "./BaseDateField.vue?vue&type=script&lang=js"
export * from "./BaseDateField.vue?vue&type=script&lang=js"
import "./BaseDateField.vue?vue&type=style&index=0&id=c4dd2762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd2762",
  null
  
)

export default component.exports